import { render, staticRenderFns } from "./DontUnderstandHowWorks.vue?vue&type=template&id=4d35c46a&"
import script from "./DontUnderstandHowWorks.vue?vue&type=script&lang=js&"
export * from "./DontUnderstandHowWorks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports